import { FaAngleUp } from 'react-icons/fa';
import { FaAngleDown } from 'react-icons/fa';
import { FaExchangeAlt } from 'react-icons/fa';
import { FaExclamationTriangle } from 'react-icons/fa';
import { FaSearch } from 'react-icons/fa';
import { FaAngleRight } from 'react-icons/fa';
import { FaTelegramPlane } from 'react-icons/fa';
import { FaTwitter } from 'react-icons/fa';

import { FiChevronDown } from 'react-icons/fi';
import { FiChevronRight } from 'react-icons/fi';

import { HiOutlineExternalLink } from 'react-icons/hi';

import { AiFillStar } from 'react-icons/ai';

import { RiArrowRightSLine } from 'react-icons/ri';

// import { MdOutlineRefresh } from 'react-icons/md';
import { MdRefresh } from 'react-icons/md';

import { IoArrowUpOutline } from 'react-icons/io5';
import { IoCloseOutline } from 'react-icons/io5';
import { IoWarning } from 'react-icons/io5';
import { IoChevronBack } from 'react-icons/io5';

import { BsArrowUpRight } from 'react-icons/bs';
import { BsCheckCircle } from 'react-icons/bs';

import { TiArrowSortedUp } from 'react-icons/ti';

// all-files missing icons
const MdOutlineRefresh = MdRefresh;

export {
  FaSearch,
  FaAngleUp,
  FaAngleDown,
  FaAngleRight,
  FaExchangeAlt,
  FaExclamationTriangle,
  FaTelegramPlane,
  FaTwitter,
  //fi
  FiChevronDown,
  FiChevronRight,
  // hi
  HiOutlineExternalLink,
  AiFillStar,
  //ri
  RiArrowRightSLine,
  MdOutlineRefresh,
  IoArrowUpOutline,
  IoCloseOutline,
  IoWarning,
  IoChevronBack,
  //bs
  BsArrowUpRight,
  BsCheckCircle,
  //ti
  TiArrowSortedUp,
};
